<template>
  <VModalWidget :dismiss="dismiss">
    <template slot="title">
      {{ $t('title') }}
    </template>

    <template slot="content">
      <p class="subheading">{{ $t('question') }}</p>
    </template>

    <template slot="footer-actions">
      <v-btn depressed color="error" @click="dismiss()">{{ $t('no') }}</v-btn>
      <v-btn depressed color="success" @click="dismiss(true)">{{ $t('yes') }}</v-btn>
    </template>
  </VModalWidget>
</template>

<script>
import VModalWidget from './VModalWidget'

export default {
  components: {
    VModalWidget
  },
  methods: {
    dismiss(v = false) {
      // $error() raises an exception that seems to escape the caller's catch()
      // using $close() with a boolean instead
      this.$close(v)
    }
  }
}
</script>

<i18n>
{
  "en": {
    "no": "@:labels.no",
    "question": "Are you sure you want to delete this item ?",
    "title": "@:labels.confirm",
    "yes": "@:labels.yes"
  },
  "fr": {
    "no": "@:labels.no",
    "question": "Êtes-vous certain de vouloir supprimer cet élement ?",
    "title": "@:labels.confirm",
    "yes": "@:labels.yes"
  }
}
</i18n>
